import { observer } from 'mobx-react'
import styles from './CustomMadeModal.module.less'
import { Modal } from 'antd'
import { IconImage } from '../Icon'
import qrCode from '@/assets/images/custom_made_wxqr.png'

export interface CustomMadeModalProps {
  visible: boolean
  onClose: () => void
}

const CustomMadeModal = observer(({ visible, onClose }: CustomMadeModalProps) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={false}
      onCancel={onClose}
      width={758}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.customMadeModal}>
        <div className={styles.modalClose} onClick={onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalContent}>
          <div className={styles.leftBox}>
            <IconImage width={116} src='IconCustomerLogo' />
            <p className={styles.title}>PPT从此会说话</p>
            <div className={styles.line}></div>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 专属客服全程跟进
            </p>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 总监级设计师精准匹配
            </p>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 专业排版｜逻辑梳理
            </p>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 快动画，定制快人一步!
            </p>
          </div>
          <div className={styles.rightBox}>
            <div className={styles.rightBoxTitle}>快动画 PPT 定制</div>
            <div className={styles.rightBoxSubtitle}>
              <IconImage src='IconWexin' width={16} />
              微信扫码联系专属客服
            </div>
            <div className={styles.customerQr}>
              <img
                className={styles.customerQrImg}
                src={qrCode}
                alt='客服二维码'
                draggable={false}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default CustomMadeModal
